import React from "react";
import Skeleton from "react-loading-skeleton";
import styles from "../Keyboard.module.css";

const KeyboardSkeleton = () => {
  return (
    <div className="wrapper-keyboard"> 
      <div className={styles.output} style={{textAlign: "center"}}>
        <Skeleton height={44}/>
      </div>
      <div className={styles.virtual_keyboard} style={{textAlign: "center"}}>
        <Skeleton height={144} width={644} />
      </div>
    </div>
  );
};

export default KeyboardSkeleton;
